const organizationDataImportStatusMapper = {
  ERRORED: "Errored",
  FINISHED: "Finished",
  PROCESSING: "Processing",
  QUEUED: "Queued",
};
export default organizationDataImportStatusMapper;
